
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pwa-development-services",
      function () {
        return require("private-next-pages/pwa-development-services.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pwa-development-services"])
      });
    }
  